import api from '../api';

const apiUrl = 'contentstreams';
const state = {
    data: {},
    meta: {}
};
const parseToJson = (value) => {
    try {
        if (typeof value === 'object' && value !== null) {
            return value;
        }

        if (typeof value === 'string') {
            return JSON.parse(value);
        }

        return {};
    } catch (error) {
        console.error('Fehler beim Parsen des JSON:', error);

        return value;
    }
};
const actions = {
    show: async ({ commit }, id) => {
        try {
            const response = await api.get(`/api/v1/${apiUrl}/${id}`);

            if (response.data.data.content) {
                const inner = async () => {
                    for (let index = 0; index < response.data.data.content.length; index++) {
                        const item = response.data.data.content[index];

                        if (item.layout === 'video') {
                            item.attributes[item.layout] = `/files/${item.attributes[item.layout]}`;
                        } else if (item.layout === 'image') {
                            item.attributes[item.layout] = `/filessec/${item.attributes[item.layout]}`;
                        } else if (item.layout === 'tab_wysiwyg_with_images' && item.attributes.images !== null) {
                            for (let innerIndex = 0; innerIndex < item.attributes.images.length; innerIndex++) {
                                item.attributes.images[innerIndex].attributes.title = parseToJson(item.attributes.images[innerIndex].attributes.title);
                                item.attributes.images[innerIndex].attributes.image = `/filessec/${item.attributes.images[innerIndex].attributes.image}`;
                            }
                        }

                        if (item.attributes.images_indicator_analysis !== null && Array.isArray(item.attributes.images_indicator_analysis)) {
                            for (let indicatorIndex = 0; indicatorIndex < item.attributes.images_indicator_analysis.length; indicatorIndex++) {
                                item.attributes.images_indicator_analysis[indicatorIndex].attributes.title = parseToJson(
                                    item.attributes.images_indicator_analysis[indicatorIndex].attributes.title
                                );
                                item.attributes.images_indicator_analysis[indicatorIndex].attributes.image =
                                    `/files/${item.attributes.images_indicator_analysis[indicatorIndex].attributes.image}`;
                            }
                        }
                    }
                };

                await inner();
            }

            commit('set', response.data);

            return response.data;
        } catch (error) {
            console.error('Fehler in der show-Methode:', error);

            // Optional: Fehler weitergeben, falls die aufrufende Methode damit umgehen soll
            return Promise.reject(error);
        }
    },
    store: async ({ commit }, data) => {
        return await api
            .post(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);

                return Promise.reject(error);
            });
    },
    update: async ({ commit }, data) => {
        return await api
            .put(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);

                return Promise.reject(error);
            });
    },
    delete: async ({ commit }, data) => {
        return await api
            .put(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);

                return Promise.reject(error);
            });
    },

    recentLinks: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}/links`, config)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);

                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
